import { Container } from '@mui/material';
import { useContext, useEffect, useState } from 'react';

import { SessionContext, SessionContextType } from '../../../contexts/session';
import { Comment } from '../../../models/Comment';
import NewComment from './NewComment/NewComment';
import PollComment from './PollComment/PollComment';
import {
    PollCommentsController,
    PollCommentsControllerState,
} from './PollCommentsController';
import {
    AnonymousUserContext,
    AnonymousUserContextType,
} from '../../../contexts/anonUser';

import './PollComments.scss';
import { PollRecord } from '../../../models/Poll';

interface PollCommentsProps {
    poll: PollRecord;
    setPoll: React.Dispatch<React.SetStateAction<PollRecord>>;
}

const PollComments = (props: PollCommentsProps): JSX.Element => {
    const { session } = useContext<SessionContextType>(SessionContext);
    const { anonUser } =
        useContext<AnonymousUserContextType>(AnonymousUserContext);
    const [comments, setComments] = useState<Comment[]>([]);
    const [pollCommentsControllerState, setPollCommentControllerState] =
        useState<PollCommentsControllerState>({
            endOfList: false,
        });

    useEffect(() => {
        if ((session.user || anonUser.user) && comments.length <= 0) {
            PollCommentsController.readMoreComments(
                props.poll.id,
                comments,
                setComments,
                pollCommentsControllerState,
                setPollCommentControllerState,
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session]);

    const onloadMoreClockHandler: React.MouseEventHandler<
        HTMLDivElement
    > = () => {
        if (!pollCommentsControllerState.endOfList) {
            PollCommentsController.readMoreComments(
                props.poll.id,
                comments,
                setComments,
                pollCommentsControllerState,
                setPollCommentControllerState,
            );
        }
    };

    return (
        <Container className='poll-comments-container'>
            <NewComment
                poll={props.poll}
                setPoll={props.setPoll}
                comments={comments}
                setComments={setComments}
            />
            {comments.length > 0 &&
                comments.map((comment) => (
                    <PollComment
                        key={comment.id}
                        comment={comment}
                        comments={comments}
                        setComments={setComments}
                    />
                ))}
            {!pollCommentsControllerState.endOfList && comments.length > 0 && (
                <Container
                    className='poll-comments-load-more-link'
                    onClick={onloadMoreClockHandler}
                >
                    Load more comments...
                </Container>
            )}
        </Container>
    );
};

export default PollComments;
